import { FlagIconCode } from 'ui/flags/flagIcons';

export const DEFAULT_COUNTRY_OPTIONS: FlagIconCode[] = ['US', 'MX', 'CA'];

export const COUNTRY_CALLING_CODES: {
  countryCode: FlagIconCode;
  countryName: string;
  callingCode: string;
}[] = [
  { countryCode: 'AD', countryName: 'Andorra', callingCode: '376' },
  { countryCode: 'AE', countryName: 'United Arab Emirates', callingCode: '971' },
  { countryCode: 'AF', countryName: 'Afghanistan', callingCode: '93' },
  { countryCode: 'AG', countryName: 'Antigua and Barbuda', callingCode: '1268' },
  { countryCode: 'AL', countryName: 'Albania', callingCode: '355' },
  { countryCode: 'AM', countryName: 'Armenia', callingCode: '374' },
  { countryCode: 'AO', countryName: 'Angola', callingCode: '244' },
  { countryCode: 'AR', countryName: 'Argentina', callingCode: '54' },
  { countryCode: 'AT', countryName: 'Austria', callingCode: '43' },
  { countryCode: 'AU', countryName: 'Australia', callingCode: '61' },
  { countryCode: 'AW', countryName: 'Aruba', callingCode: '297' },
  { countryCode: 'AZ', countryName: 'Azerbaijan', callingCode: '994' },
  { countryCode: 'BA', countryName: 'Bosnia and Herzegovina', callingCode: '387' },
  { countryCode: 'BB', countryName: 'Barbados', callingCode: '1246' },
  { countryCode: 'BD', countryName: 'Bangladesh', callingCode: '880' },
  { countryCode: 'BE', countryName: 'Belgium', callingCode: '32' },
  { countryCode: 'BF', countryName: 'Burkina Faso', callingCode: '226' },
  { countryCode: 'BG', countryName: 'Bulgaria', callingCode: '359' },
  { countryCode: 'BH', countryName: 'Bahrain', callingCode: '973' },
  { countryCode: 'BI', countryName: 'Burundi', callingCode: '257' },
  { countryCode: 'BJ', countryName: 'Benin', callingCode: '229' },
  { countryCode: 'BN', countryName: 'Brunei', callingCode: '673' },
  { countryCode: 'BO', countryName: 'Bolivia', callingCode: '591' },
  { countryCode: 'BR', countryName: 'Brazil', callingCode: '55' },
  { countryCode: 'BS', countryName: 'Bahamas', callingCode: '1242' },
  { countryCode: 'BT', countryName: 'Bhutan', callingCode: '975' },
  { countryCode: 'BW', countryName: 'Botswana', callingCode: '267' },
  { countryCode: 'BY', countryName: 'Belarus', callingCode: '375' },
  { countryCode: 'BZ', countryName: 'Belize', callingCode: '501' },
  { countryCode: 'CA', countryName: 'Canada', callingCode: '1' },
  { countryCode: 'CD', countryName: 'Democratic Republic of the Congo', callingCode: '243' },
  { countryCode: 'CF', countryName: 'Central African Republic', callingCode: '236' },
  { countryCode: 'CG', countryName: 'Republic of the Congo', callingCode: '242' },
  { countryCode: 'CH', countryName: 'Switzerland', callingCode: '41' },
  { countryCode: 'CI', countryName: 'Ivory Coast', callingCode: '225' },
  { countryCode: 'CL', countryName: 'Chile', callingCode: '56' },
  { countryCode: 'CM', countryName: 'Cameroon', callingCode: '237' },
  { countryCode: 'CN', countryName: 'China', callingCode: '86' },
  { countryCode: 'CO', countryName: 'Colombia', callingCode: '57' },
  { countryCode: 'CR', countryName: 'Costa Rica', callingCode: '506' },
  { countryCode: 'CU', countryName: 'Cuba', callingCode: '53' },
  { countryCode: 'CV', countryName: 'Cape Verde', callingCode: '238' },
  { countryCode: 'CW', countryName: 'Curacao', callingCode: '599' },
  { countryCode: 'CY', countryName: 'Cyprus', callingCode: '357' },
  { countryCode: 'CZ', countryName: 'Czech Republic', callingCode: '420' },
  { countryCode: 'DE', countryName: 'Germany', callingCode: '49' },
  { countryCode: 'DJ', countryName: 'Djibouti', callingCode: '253' },
  { countryCode: 'DK', countryName: 'Denmark', callingCode: '45' },
  { countryCode: 'DM', countryName: 'Dominica', callingCode: '1767' },
  { countryCode: 'DO', countryName: 'Dominican Republic', callingCode: '1' },
  { countryCode: 'DZ', countryName: 'Algeria', callingCode: '213' },
  { countryCode: 'EC', countryName: 'Ecuador', callingCode: '593' },
  { countryCode: 'EE', countryName: 'Estonia', callingCode: '372' },
  { countryCode: 'EG', countryName: 'Egypt', callingCode: '20' },
  { countryCode: 'ER', countryName: 'Eritrea', callingCode: '291' },
  { countryCode: 'ES', countryName: 'Spain', callingCode: '34' },
  { countryCode: 'ET', countryName: 'Ethiopia', callingCode: '251' },
  { countryCode: 'FI', countryName: 'Finland', callingCode: '358' },
  { countryCode: 'FJ', countryName: 'Fiji', callingCode: '679' },
  { countryCode: 'FM', countryName: 'Micronesia', callingCode: '691' },
  { countryCode: 'FR', countryName: 'France', callingCode: '33' },
  { countryCode: 'GA', countryName: 'Gabon', callingCode: '241' },
  { countryCode: 'GB', countryName: 'United Kingdom', callingCode: '44' },
  { countryCode: 'GD', countryName: 'Grenada', callingCode: '1473' },
  { countryCode: 'GE', countryName: 'Georgia', callingCode: '995' },
  { countryCode: 'GH', countryName: 'Ghana', callingCode: '233' },
  { countryCode: 'GM', countryName: 'Gambia', callingCode: '220' },
  { countryCode: 'GN', countryName: 'Guinea', callingCode: '224' },
  { countryCode: 'GQ', countryName: 'Equatorial Guinea', callingCode: '240' },
  { countryCode: 'GR', countryName: 'Greece', callingCode: '30' },
  { countryCode: 'GT', countryName: 'Guatemala', callingCode: '502' },
  { countryCode: 'GW', countryName: 'Guinea-Bissau', callingCode: '245' },
  { countryCode: 'GY', countryName: 'Guyana', callingCode: '592' },
  { countryCode: 'HK', countryName: 'Hong Kong', callingCode: '852' },
  { countryCode: 'HN', countryName: 'Honduras', callingCode: '504' },
  { countryCode: 'HR', countryName: 'Croatia', callingCode: '385' },
  { countryCode: 'HT', countryName: 'Haiti', callingCode: '509' },
  { countryCode: 'HU', countryName: 'Hungary', callingCode: '36' },
  { countryCode: 'ID', countryName: 'Indonesia', callingCode: '62' },
  { countryCode: 'IE', countryName: 'Ireland', callingCode: '353' },
  { countryCode: 'IL', countryName: 'Israel', callingCode: '972' },
  { countryCode: 'IN', countryName: 'India', callingCode: '91' },
  { countryCode: 'IQ', countryName: 'Iraq', callingCode: '964' },
  { countryCode: 'IR', countryName: 'Iran', callingCode: '98' },
  { countryCode: 'IS', countryName: 'Iceland', callingCode: '354' },
  { countryCode: 'IT', countryName: 'Italy', callingCode: '39' },
  { countryCode: 'JM', countryName: 'Jamaica', callingCode: '1876' },
  { countryCode: 'JO', countryName: 'Jordan', callingCode: '962' },
  { countryCode: 'JP', countryName: 'Japan', callingCode: '81' },
  { countryCode: 'KE', countryName: 'Kenya', callingCode: '254' },
  { countryCode: 'KG', countryName: 'Kyrgyzstan', callingCode: '996' },
  { countryCode: 'KH', countryName: 'Cambodia', callingCode: '855' },
  { countryCode: 'KI', countryName: 'Kiribati', callingCode: '686' },
  { countryCode: 'KM', countryName: 'Comoros', callingCode: '269' },
  { countryCode: 'KP', countryName: 'North Korea', callingCode: '850' },
  { countryCode: 'KR', countryName: 'South Korea', callingCode: '82' },
  { countryCode: 'KW', countryName: 'Kuwait', callingCode: '965' },
  { countryCode: 'KZ', countryName: 'Kazakhstan', callingCode: '7' },
  { countryCode: 'LA', countryName: 'Laos', callingCode: '856' },
  { countryCode: 'LB', countryName: 'Lebanon', callingCode: '961' },
  { countryCode: 'LC', countryName: 'Saint Lucia', callingCode: '1758' },
  { countryCode: 'LI', countryName: 'Liechtenstein', callingCode: '423' },
  { countryCode: 'LK', countryName: 'Sri Lanka', callingCode: '94' },
  { countryCode: 'LR', countryName: 'Liberia', callingCode: '231' },
  { countryCode: 'LS', countryName: 'Lesotho', callingCode: '266' },
  { countryCode: 'LT', countryName: 'Lithuania', callingCode: '370' },
  { countryCode: 'LU', countryName: 'Luxembourg', callingCode: '352' },
  { countryCode: 'LV', countryName: 'Latvia', callingCode: '371' },
  { countryCode: 'LY', countryName: 'Libya', callingCode: '218' },
  { countryCode: 'MA', countryName: 'Morocco', callingCode: '212' },
  { countryCode: 'MC', countryName: 'Monaco', callingCode: '377' },
  { countryCode: 'MD', countryName: 'Moldova', callingCode: '373' },
  { countryCode: 'ME', countryName: 'Montenegro', callingCode: '382' },
  { countryCode: 'MG', countryName: 'Madagascar', callingCode: '261' },
  { countryCode: 'MH', countryName: 'Marshall Islands', callingCode: '692' },
  { countryCode: 'MK', countryName: 'Macedonia', callingCode: '389' },
  { countryCode: 'ML', countryName: 'Mali', callingCode: '223' },
  { countryCode: 'MM', countryName: 'Myanmar', callingCode: '95' },
  { countryCode: 'MN', countryName: 'Mongolia', callingCode: '976' },
  { countryCode: 'MR', countryName: 'Mauritania', callingCode: '222' },
  { countryCode: 'MS', countryName: 'Montserrat', callingCode: '1664' },
  { countryCode: 'MT', countryName: 'Malta', callingCode: '356' },
  { countryCode: 'MU', countryName: 'Mauritius', callingCode: '230' },
  { countryCode: 'MV', countryName: 'Maldives', callingCode: '960' },
  { countryCode: 'MW', countryName: 'Malawi', callingCode: '265' },
  { countryCode: 'MX', countryName: 'Mexico', callingCode: '52' },
  { countryCode: 'MY', countryName: 'Malaysia', callingCode: '60' },
  { countryCode: 'MZ', countryName: 'Mozambique', callingCode: '258' },
  { countryCode: 'NA', countryName: 'Namibia', callingCode: '264' },
  { countryCode: 'NE', countryName: 'Niger', callingCode: '227' },
  { countryCode: 'NG', countryName: 'Nigeria', callingCode: '234' },
  { countryCode: 'NI', countryName: 'Nicaragua', callingCode: '505' },
  { countryCode: 'NL', countryName: 'Netherlands', callingCode: '31' },
  { countryCode: 'NO', countryName: 'Norway', callingCode: '47' },
  { countryCode: 'NP', countryName: 'Nepal', callingCode: '977' },
  { countryCode: 'NR', countryName: 'Nauru', callingCode: '674' },
  { countryCode: 'NZ', countryName: 'New Zealand', callingCode: '64' },
  { countryCode: 'OM', countryName: 'Oman', callingCode: '968' },
  { countryCode: 'PA', countryName: 'Panama', callingCode: '507' },
  { countryCode: 'PE', countryName: 'Peru', callingCode: '51' },
  { countryCode: 'PG', countryName: 'Papua New Guinea', callingCode: '675' },
  { countryCode: 'PH', countryName: 'Philippines', callingCode: '63' },
  { countryCode: 'PK', countryName: 'Pakistan', callingCode: '92' },
  { countryCode: 'PL', countryName: 'Poland', callingCode: '48' },
  { countryCode: 'PR', countryName: 'Puerto Rico', callingCode: '1' },
  { countryCode: 'PS', countryName: 'Palestine', callingCode: '970' },
  { countryCode: 'PT', countryName: 'Portugal', callingCode: '351' },
  { countryCode: 'PW', countryName: 'Palau', callingCode: '680' },
  { countryCode: 'PY', countryName: 'Paraguay', callingCode: '595' },
  { countryCode: 'QA', countryName: 'Qatar', callingCode: '974' },
  { countryCode: 'RO', countryName: 'Romania', callingCode: '40' },
  { countryCode: 'RS', countryName: 'Serbia', callingCode: '381' },
  { countryCode: 'RU', countryName: 'Russia', callingCode: '7' },
  { countryCode: 'RW', countryName: 'Rwanda', callingCode: '250' },
  { countryCode: 'SA', countryName: 'Saudi Arabia', callingCode: '966' },
  { countryCode: 'SB', countryName: 'Solomon Islands', callingCode: '677' },
  { countryCode: 'SC', countryName: 'Seychelles', callingCode: '248' },
  { countryCode: 'SD', countryName: 'Sudan', callingCode: '249' },
  { countryCode: 'SE', countryName: 'Sweden', callingCode: '46' },
  { countryCode: 'SG', countryName: 'Singapore', callingCode: '65' },
  { countryCode: 'SI', countryName: 'Slovenia', callingCode: '386' },
  { countryCode: 'SK', countryName: 'Slovakia', callingCode: '421' },
  { countryCode: 'SL', countryName: 'Sierra Leone', callingCode: '232' },
  { countryCode: 'SM', countryName: 'San Marino', callingCode: '378' },
  { countryCode: 'SN', countryName: 'Senegal', callingCode: '221' },
  { countryCode: 'SO', countryName: 'Somalia', callingCode: '252' },
  { countryCode: 'SR', countryName: 'Suriname', callingCode: '597' },
  { countryCode: 'SS', countryName: 'South Sudan', callingCode: '211' },
  { countryCode: 'ST', countryName: 'Sao Tome and Principe', callingCode: '239' },
  { countryCode: 'SV', countryName: 'El Salvador', callingCode: '503' },
  { countryCode: 'SX', countryName: 'Sint Maarten', callingCode: '1721' },
  { countryCode: 'SY', countryName: 'Syria', callingCode: '963' },
  { countryCode: 'SZ', countryName: 'Swaziland', callingCode: '268' },
  { countryCode: 'TD', countryName: 'Chad', callingCode: '235' },
  { countryCode: 'TG', countryName: 'Togo', callingCode: '228' },
  { countryCode: 'TH', countryName: 'Thailand', callingCode: '66' },
  { countryCode: 'TJ', countryName: 'Tajikistan', callingCode: '992' },
  { countryCode: 'TL', countryName: 'East Timor', callingCode: '670' },
  { countryCode: 'TM', countryName: 'Turkmenistan', callingCode: '993' },
  { countryCode: 'TN', countryName: 'Tunisia', callingCode: '216' },
  { countryCode: 'TO', countryName: 'Tonga', callingCode: '676' },
  { countryCode: 'TR', countryName: 'Turkey', callingCode: '90' },
  { countryCode: 'TT', countryName: 'Trinidad and Tobago', callingCode: '1868' },
  { countryCode: 'TV', countryName: 'Tuvalu', callingCode: '688' },
  { countryCode: 'TW', countryName: 'Taiwan', callingCode: '886' },
  { countryCode: 'TZ', countryName: 'Tanzania', callingCode: '255' },
  { countryCode: 'UA', countryName: 'Ukraine', callingCode: '380' },
  { countryCode: 'UG', countryName: 'Uganda', callingCode: '256' },
  { countryCode: 'US', countryName: 'United States', callingCode: '1' },
  { countryCode: 'UY', countryName: 'Uruguay', callingCode: '598' },
  { countryCode: 'UZ', countryName: 'Uzbekistan', callingCode: '998' },
  { countryCode: 'VA', countryName: 'Vatican', callingCode: '379' },
  { countryCode: 'VC', countryName: 'Saint Vincent and the Grenadines', callingCode: '1784' },
  { countryCode: 'VE', countryName: 'Venezuela', callingCode: '58' },
  { countryCode: 'VI', countryName: 'U.S. Virgin Islands', callingCode: '1340' },
  { countryCode: 'VN', countryName: 'Vietnam', callingCode: '84' },
  { countryCode: 'VU', countryName: 'Vanuatu', callingCode: '678' },
  { countryCode: 'WS', countryName: 'Samoa', callingCode: '685' },
  { countryCode: 'YE', countryName: 'Yemen', callingCode: '967' },
  { countryCode: 'ZA', countryName: 'South Africa', callingCode: '27' },
  { countryCode: 'ZM', countryName: 'Zambia', callingCode: '260' },
  { countryCode: 'ZW', countryName: 'Zimbabwe', callingCode: '263' },
];
